import Compressor from 'compressorjs'

export interface CreateFilePayload {
  folderId: number
  companyId: number
  description: string | null
  newFile: File
}

export function fileSize(size: number) {
  if (!size) return '0 Bytes'

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(size) / Math.log(1024))

  return `${parseFloat((size / 1024 ** i).toFixed(2))} ${sizes[i]}`
}

export async function serializeFile({ newFile, companyId, folderId, description }: CreateFilePayload): Promise<FormData> {
  const formData = new FormData()
  const file = newFile.type?.includes('image') ? await _compress(newFile) : newFile.name

  formData.append('file', file as Blob, newFile.name)
  formData.append('name', newFile.name)
  formData.append('company_id', companyId.toString())
  formData.append('folder_id', folderId.toString())

  if (description) {
    formData.append('description', description)
  }

  return formData
}

async function _compress(file: File): Promise<Blob> {
  return new Promise<File>((resolve, reject) => {
    new Compressor(file, {
      // The compressor uses its own arbitrary scale instead of actually
      // rationing the original image. Experimentally this seems to be about the right
      // value to actually reduce the image size.
      quality: 0.8,
      checkOrientation: false,
      success(result: File) {
        resolve(result)
      },
      error(err: Error) {
        reject(err)
      },
    })
  })
}
